import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin, Twitter, MessageCircle } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-primary text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="col-span-1">
            <img
              src="https://customer-assets.emergentagent.com/job_canada-pathway-3/artifacts/wzgtavxp_IMG_0276-removebg-preview.png"
              alt="ELARA Education"
              className="h-12 w-auto mb-4"
              data-testid="footer-logo"
            />
            <p className="text-slate-300 text-sm leading-relaxed">
              Your trusted education partner in Canada. Guiding students to success with transparency and care.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-secondary">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-secondary text-sm transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-secondary text-sm transition-colors" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-secondary text-sm transition-colors" data-testid="footer-link-services">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/programs" className="text-slate-300 hover:text-secondary text-sm transition-colors" data-testid="footer-link-programs">
                  Programs
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-secondary text-sm transition-colors" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-secondary">Services</h4>
            <ul className="space-y-2 text-slate-300 text-sm">
              <li>College Admissions</li>
              <li>International Student Support</li>
              <li>Domestic Student Guidance</li>
              <li>Career Counseling</li>
              <li>Application Assistance</li>
              <li>Language Programs</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-secondary">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-slate-300 text-sm">
                <Mail size={18} className="mt-0.5 text-secondary" />
                <a href="mailto:apply@elaraeducation.com" className="hover:text-secondary transition-colors">
                  apply@elaraeducation.com
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-300 text-sm">
                <Phone size={18} className="mt-0.5 text-secondary" />
                <a href="tel:+16474696738" className="hover:text-secondary transition-colors">
                  +1 (647) 469-6738
                </a>
              </li>
              <li className="flex items-start gap-2 text-slate-300 text-sm">
                <MapPin size={18} className="mt-0.5 text-secondary" />
                <span>1500 Meyerside Dr, Mississauga, ON L5T 1V4</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.instagram.com/elara_education?igsh=MXV4Znk0Y2s3M3Q1eQ%3D%3D&utm_source=qr" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-secondary transition-colors" 
                data-testid="footer-social-instagram"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://wa.me/16474696738" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-secondary transition-colors" 
                data-testid="footer-social-whatsapp"
                aria-label="WhatsApp"
              >
                <MessageCircle size={20} />
              </a>
              <a 
                href="https://facebook.com/elaraeducation" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-secondary transition-colors" 
                data-testid="footer-social-facebook"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://linkedin.com/company/elaraeducation" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-secondary transition-colors" 
                data-testid="footer-social-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://twitter.com/elaraeducation" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-300 hover:text-secondary transition-colors" 
                data-testid="footer-social-twitter"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} ELARA Education. All rights reserved.</p>
          <p className="mt-2 text-xs">
            Registered Education Consulting Company | Compliant with Canadian Education Standards
          </p>
        </div>
      </div>
    </footer>
  );
};